import { Event } from 'typescript.events';

import type { ICrawlOptions, IInfoList } from './interfaces/crawl.interface';
import type { IFound, IGetDetailResult } from './interfaces/get-detail.interface';
import { ERarity } from './interfaces/crawl.interface';
import { convertArrayToObject, getRarity, waitFor } from './lib/utils';

import getListItem from './lib/get-list-item';
import getDetailItem from './lib/get-detail-item';

class MetamonCrawler extends Event {
  options: any;
  currentPage: any;
  more: boolean;
  isPause: boolean;
  constructor(options: ICrawlOptions) {
    const defaultOptions = {
      maxPage: 0,
      fromPage: 1,
      minPrice: 0,
      maxPrice: 999999999,
      baseLevel: 10,
      minPower: 315,
      rarity: ERarity.N,
      sleep: 5,
    };
    const finalOptions = {
      ...defaultOptions,
      ...options,
    };

    super();
    this.isPause = false;
    this.more = true;
    this.options = finalOptions;
    this.currentPage = finalOptions.fromPage;
  }

  public async start() {
    this.isPause = false;
    this.emit('status', 'Started');
    do {
      const params = {
        pageNo: this.currentPage,
        pageSize: 20,
        sortBy: 'created_at',
        order: 'desc',
        category: getRarity(this.options.rarity),
      };

      const listItem = await getListItem(params);

      this.more =
        (this.currentPage + 1 <= this.options.maxPage ||
          this.options.maxPage == 0) &&
        listItem.has_next;

      const initInfo: IInfoList = {
        total: listItem.total,
        pageSize: 20,
        currentPage: this.currentPage,
        more: this.more,
      };

      this.emit('init', initInfo);

      const filteredItems = listItem.data.filter((item) => {
        const totalPrice = item.fixed_price * item.count;
        return (
          totalPrice <= this.options.maxPrice &&
          totalPrice >= this.options.minPrice
        );
      });

      const items = (await Promise.allSettled(
        await filteredItems.map((item) => getDetailItem(item.id)),
      )) as any;

      const fulfilledItems = items
        .filter((item: any) => item.status === 'fulfilled')
        .map((item: any) => item.value);

      fulfilledItems.forEach((item: IGetDetailResult) => {
        const properties = convertArrayToObject(item.properties, 'key');

        if ((properties.Score >= this.options.minPower) && (properties.Level >= this.options.baseLevel)) {
         
          const itemEmit: IFound = {
            ...item,
            properties
          }

          this.emit('found', itemEmit);
        }
      });

      this.currentPage = this.currentPage + 1;
      if(!this.more){
        this.emit('status', 'Done');
      }
      await waitFor(this.options.sleep * 1000);
    } while (this.more && this.isPause == false);
  }

  public pause() {
    this.emit('status', 'Paused');
    this.isPause = true;
  }

  public stop() {
    this.emit('status', 'Stopped');
    this.isPause = true;
    this.currentPage = this.options.fromPage;
    this.more = true;
  }
}

// const crawler = new MetamonCrawler({
//   minPower: 325,
//   sleep: 0
//  })

//  crawler.start()
//  crawler.on('init', console.log)
//  crawler.on('found', console.log)

export default MetamonCrawler;
export * from './interfaces/crawl.interface';
export * from './interfaces/get-detail.interface';
export * from './lib/utils';
export * from './lib/get-list-item';
export * from './lib/get-detail-item';
